/**
 * 图层复合面板（M4-05 / DESIGN.md#65-值得从-photoshop-补充的功能性价比排序）。
 *
 * 纯展示组件：复合列表进、意图出，不认识 store（与 LayersPanel 同一条规则）。
 */
import type { JSX } from 'solid-js';
import { For, Show, createSignal } from 'solid-js';
import type { LayerComp } from '../../document/types';
import styles from './LayerCompsPanel.module.css';

export interface LayerCompsPanelProps {
  readonly comps: readonly LayerComp[];
  readonly onCreate: (name: string) => void;
  readonly onApply: (id: string) => void;
  readonly onDelete: (id: string) => void;
}

export function LayerCompsPanel(props: LayerCompsPanelProps): JSX.Element {
  const [name, setName] = createSignal('复合 1');

  return (
    <div class={styles.panel} data-testid="layer-comps-panel">
      <div class={styles.createRow}>
        <input
          class={styles.nameInput}
          type="text"
          value={name()}
          data-testid="layer-comp-name-input"
          onInput={(event) => setName(event.currentTarget.value)}
        />
        <button
          type="button"
          class={styles.createButton}
          data-testid="layer-comp-create"
          onClick={() => props.onCreate(name())}
        >
          + 新建复合
        </button>
      </div>
      <ul class={styles.list} data-testid="layer-comps-list">
        <For each={props.comps}>
          {(comp) => (
            <li class={styles.item} data-testid={`layer-comp-item-${comp.id}`}>
              <span class={styles.itemName}>{comp.name}</span>
              <div class={styles.itemButtons}>
                <button type="button" onClick={() => props.onApply(comp.id)}>
                  应用
                </button>
                <button type="button" onClick={() => props.onDelete(comp.id)}>
                  删除
                </button>
              </div>
            </li>
          )}
        </For>
        <Show when={props.comps.length === 0}>
          <li class={styles.empty}>还没有图层复合</li>
        </Show>
      </ul>
    </div>
  );
}
